import type { ToolName } from './names';
import { TOOL_NAME_VALUES } from './TOOL_NAME_VALUES';

export const isToolName = (name: string): boolean => {
	return TOOL_NAME_VALUES.includes(name as ToolName);
};
